import { useCallback, useMemo } from 'react';
import TowerCardComponent from '../Row/Card';
import { TowerCellsProps } from './props';

import { useOriginalsMove } from '@/api/bets';
import { GameID } from '@/enums/gameId';
import styles from './styles.module.scss';

export default function TowerCells({
  difficulty,
  bet,
  rowsCleared,
  isBoletim,
}: TowerCellsProps) {
  const cellsQuantity = useMemo(
    () => difficulty?.columns * difficulty?.lines,
    [difficulty],
  );
  const { moveBet, isPending: isLoadingMoveBet } = useOriginalsMove({
    gameId: GameID.Tower,
  });

  const onRowClick = useCallback(
    (position: number) => {
      moveBet({
        betId: bet?.id,
        gameId: GameID.Tower,
        grid: {
          cell: position,
        },
      });
    },
    [moveBet, bet],
  );

  const Grid: JSX.Element[] = useMemo(() => {
    return Array.from({ length: cellsQuantity ?? 36 }).map((_, index) => (
      <TowerCardComponent
        position={cellsQuantity - index - 1}
        key={`tower-card-${index}`}
        isLoading={isLoadingMoveBet}
        onRowClick={onRowClick}
        bet={bet}
        rowsCleared={rowsCleared}
        isBoletim={isBoletim}
        columns={difficulty?.columns}
      />
    ));
  }, [
    cellsQuantity,
    bet,
    rowsCleared,
    onRowClick,
    isLoadingMoveBet,
    isBoletim,
    difficulty?.columns,
  ]);

  return (
    <div
      className={`${styles.container} ${isBoletim ? styles['container--boletim'] : ''}`}
      style={{
        gridTemplateColumns: `repeat(${difficulty?.columns ?? 3}, 1fr)`,
      }}
    >
      {Grid}
    </div>
  );
}
